
import { Component, Mixins, Emit } from 'vue-property-decorator';
import { iBackupTactics, eRulesDialogContentStatus } from '@/interface/backup-tactics';
import { getBackupList, delBackupByID, getBackupSelectList } from '@/api/backup-tactics';
import { GameArea } from '@/mixins/game_area';
import { PageQuery } from '@/mixins/page_query';
import { getWeeks, formatterHour } from '@/utils/common';
import EditBackupTactics from './_EditBackupTactics.vue';

@Component({
  components: {
    EditBackupTactics,
  },
})
export default class DeviceTable extends Mixins(GameArea, PageQuery) {
  private dialogVisible = false;
  private isEdit = false;
  private query = {
    name: '',
  };
  editor: boolean = false;
  private tableList: iBackupTactics[] = [];
  private defalutModel: any = [];

  //加载数据状态
  loading: boolean = false;
  rulesDialogStatus: eRulesDialogContentStatus = eRulesDialogContentStatus.CREATE;
  // @Emit() godetail(obj: iNetbar) {
  //   console.log('go detail', obj);
  // }
  weekList: Array<any> = getWeeks();
  closeDialog() {
    this.dialogVisible = false;
  }
  handlerSuccess() {
    this.closeDialog();
    this.searchList();
  }

  closeModal() {
    this.dialogVisible = false;
    this.getBackupList();
  }

  showEdit(row: iBackupTactics) {
    this.defalutModel = JSON.parse(JSON.stringify(row));
    this.rulesDialogStatus = eRulesDialogContentStatus.EDIT;
    this.dialogVisible = true;
  }
  showDetail(row: iBackupTactics) {
    this.defalutModel = JSON.parse(JSON.stringify(row));
    this.rulesDialogStatus = eRulesDialogContentStatus.INFO;
    this.dialogVisible = true;
  }
  addBackup() {
    this.rulesDialogStatus = eRulesDialogContentStatus.CREATE;
    this.defalutModel = null;
    this.dialogVisible = true;
  }
  removeRow(id: number) {
    // const h = this.$createElement;
    let msgStr = '';

    this.$msgbox({
      title: '是否确定删除该策略？',
      type: 'warning',
      // message: h('p', undefined, [h('i', { style: 'color: red' }, '删除后不可恢复'), h('span', undefined, ' 你还要继续吗？ ')]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          // 发送删除请求
          try {
            const res: any = await this.delRow(id);
            const { code, msg } = res;
            if (code == 0) {
              msgStr = msg;
            }
          } catch (err) {
            console.log(err, '11111111111');
          } finally {
            done();
            instance.confirmButtonLoading = false;
          }
        } else {
          done();
        }
      },
    }).then(action => {
      if (msgStr === '成功') {
        this.$message({
          type: 'success',
          message: '删除成功',
        });
        this.getBackupList();
      } else {
        this.errorShow(msgStr);
      }
    });
  }
  errorShow(msg: string) {
    const h = this.$createElement;
    this.$msgbox({
      title: '提示',
      message: h('p', undefined, [
        h('div', { style: ' text-align:center' }, '该策略，绑定了算力节点：' + msg),
        h('div', { style: ' text-align:center' }, '请解除绑定后，再删除！'),
      ]),
    });
  }
  /**
   * 改变选择
   */
  changeSelect() {
    this.searchList();
  }
  searchList() {
    this.page_query.page = 1;
    this.getBackupList();
  }
  @Emit() goback() {}
  async getBackupList() {
    this.loading = true;
    try {
      const res = await getBackupList({ ...this.query, ...this.page_query });
      this.loading = false;
      if (res) {
        this.tableList = res.data.list;

        this.total = res.data.total;
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }

  async delRow(id: number) {
    const res = await delBackupByID({ id: id });
    return res;
  }
  getBackupValue(row: any) {
    let value = '';

    const { custom, common } = row;
    // console.log(custom, common, '1');

    if (custom) {
      custom.forEach((item: any, index: number) => {
        let weeks = ''; //得到周期
        let times = ''; //时间；
        let configs = ''; //配置
        let defaultConfigs = ''; //默认配置

        const { backup_days, backup_num, backup_periods } = item;
        /* 周期 */
        backup_days.forEach((dayItem: string) => {
          this.weekList.find((weekItem: any) => {
            if (dayItem == weekItem.value) {
              weeks += weekItem.label + ',';
            }
          });
        });
        weeks = weeks.substring(0, weeks.length - 1);
        /* 自定义配置 */
        /* 时间 */
        backup_periods.forEach((timeItem: any) => {
          times += formatterHour(timeItem.start) + '~' + formatterHour(timeItem.end) + '&nbsp;&nbsp';
        });
        // times = times.substring(0, times.length - 1);

        /* 配置信息 */
        const configStr = this.getConfig(backup_num);
        if (value != '') {
          value += '&nbsp;&nbsp';
        }
        value += weeks + '&nbsp;&nbsp;' + times + '&nbsp;&nbsp ' + configStr;
      });
    }

    /* 普通时段 */
    if (common) {
      value += '</br>普通时段：' + this.getConfig(common.backup_num);
    }
    return value;
  }
  getConfig(item: any) {
    let str = '';
    str += this.getHLFConfg(item.high, '高配');
    str += this.getHLFConfg(item.low, '标配');
    if (item.lux) {
      str += this.getHLFConfg(item.lux, '尊享');
    }
    str += this.getHLFConfg(item.free, '体验');
    return str;
  }
  getHLFConfg(item: any, title: string) {
    let max = item.max;
    let min = item.min;
    let str = `${title}&nbsp;${min}~${max} &nbsp;`;
    return str;
  }
  mounted() {
    this.pageFn = this.getBackupList;
    this.getBackupList();
  }
}
